import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { GenericFilterModel } from 'src/app/security/QueryStringParam';
import { AnnouncementModel, Contacts, DataItemModel } from '../../../shared/model/interfaces';
import {extractContacts, getErrorMessageText} from '../../helper';

@Component({
    selector: 'app-user-home',
    templateUrl: './user-home.component.html',
    styleUrls: ['./user-home.component.css'],
    standalone: false
})
export class UserHomeComponent implements OnInit {

  public forms: DataItemModel[] = [];
  public statements: DataItemModel[] = [];
  public taxes: DataItemModel[] = [];
  public communications: DataItemModel[] = [];
  public confirms: DataItemModel[] = [];

  public user: any;
  public Announcements: AnnouncementModel[] = [];
  public OwnerShipType = '-';
  public CustodianAccNum = '-';
  public contacts: Contacts;
  public differentLoggedIn: boolean;
  display = false;
  alertMessage: string;
  InboxCount = 0;


  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private ngxService: NgxUiLoaderService,
    private authService: AuthServiceCustom) {
  }

  ngOnInit() {

    this.differentLoggedIn = this.authService.DifferentLoggedIn;
    const genericFilterModel = new GenericFilterModel();
    genericFilterModel.Filters = [];

    genericFilterModel.PageNo = 0;
    genericFilterModel.PageSize = 3;
    genericFilterModel.SortField = '';
    genericFilterModel.SortOrder = '';
    genericFilterModel.SkipRecords = 0;
    genericFilterModel.Filters.push({Key: 'forWhat', Value: 'announcement'});
    forkJoin(
      this.abstractDataProvider.postData(genericFilterModel, 'api/Form/GetForm'),
      this.abstractDataProvider.getData('api/User/GetUserInfo'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetNewMessageCount'),
      this.abstractDataProvider.postData(genericFilterModel, 'api/Inbox/GetInbox')
    )
      .subscribe(([forms, user, inbox, announcement]) => {// statment, tax,
          this.ngxService.stop();

          this.user = user;

          this.contacts = extractContacts(user);
          this.OwnerShipType = user.OwnerShipType;
          this.CustodianAccNum = user.CustodianAccNum;

          this.forms = forms.Data.slice(0, 4);
          this.InboxCount = inbox.InboxCount;
          this.Announcements = announcement.Data;

        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);

        });
  }


  onConfirm() {
    this.display = false;
  }


}
